// Tiny inline bar chart of a 1-4 answer distribution. Shown beside every
// item because a mean of 2.5 from {1,4} means something very different from
// {2,3} (handoff Section 8.1).

import type { JSX } from 'react';
import { distributionEvidence } from '../format';

interface DistributionBarsProps {
  distribution: { 1: number; 2: number; 3: number; 4: number };
}

export function DistributionBars({ distribution }: DistributionBarsProps): JSX.Element {
  const values = [1, 2, 3, 4] as const;
  const max = Math.max(1, ...values.map((v) => distribution[v]));
  const evidence = distributionEvidence(distribution) || 'no answers yet';
  return (
    <span className="dist-bars" role="img" aria-label={evidence} title={evidence}>
      {values.map((v) => {
        const count = distribution[v];
        const height = count === 0 ? 2 : Math.max(4, Math.round((count / max) * 26));
        return (
          <span
            key={v}
            className={count > 0 ? 'dist-bar dist-bar-filled' : 'dist-bar'}
            style={{ height }}
          />
        );
      })}
    </span>
  );
}
